import styled from 'styled-components';

import { Icon } from '../Icon';

const DropdownToggleIcon = styled(Icon)`
  display: inline-flex;
  flex-shrink: 0;
  transition: 150ms linear;
  margin-left: auto;

  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(-180deg)' : 'rotate(0deg)')};
`;

export { DropdownToggleIcon };
